// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.buttonNavbar {
  border: none;
  border-radius: 30px !important;
  padding-top: 7px !important;
  padding-bottom: 7px !important;
  background-color: lightgrey;
}

.buttonNavbar1:hover {
  color: lightgray !important;
}

.buttonNavbar2:hover {
  color: gray !important;
}

:host {
  background: #ffffff;
  border-bottom: 1px solid #dfe4ed;
  display: block;
  height: 70px;
  left: 220px;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 9998;
}
@media screen and (max-width: 2048px) {
  :host {
    left: 0;
  }
}
.rtl :host {
  left: 0;
  right: 220px;
}
@media screen and (max-width: 2048px) {
  .rtl :host {
    right: 0;
  }
}
:host .site-navbar {
  align-items: center;
  display: flex;
  flex-wrap: nowrap;
  height: 100%;
  justify-content: space-between;
  padding: 0 22px;
}
@media screen and (max-width: 2048px) {
  :host .site-navbar {
    flex-wrap: wrap;
  }
}
:host .site-navbar .navbar-button {
  cursor: pointer;
  display: none;
  height: 24px;
  margin: 0;
  position: relative;
  transform: rotate(0deg);
  width: 30px;
}
@media screen and (max-width: 2048px) {
  :host .site-navbar .navbar-button {
    display: block;
  }
}
:host .site-navbar .navbar-button span {
  background: #3c4e62;
  display: block;
  height: 3px;
  opacity: 1;
  position: absolute;
  transform: rotate(0deg);
  transition: 0.25s ease-in-out;
  width: 50%;
}
:host .site-navbar .navbar-button span:nth-child(even) {
  left: 50%;
}
:host .site-navbar .navbar-button span:nth-child(odd) {
  left: 0px;
}
:host .site-navbar .navbar-button span:nth-child(1), :host .site-navbar .navbar-button span:nth-child(2) {
  top: 0px;
}
:host .site-navbar .navbar-button span:nth-child(3), :host .site-navbar .navbar-button span:nth-child(4) {
  top: 10px;
}
:host .site-navbar .navbar-button span:nth-child(5), :host .site-navbar .navbar-button span:nth-child(6) {
  top: 20px;
}
:host .site-navbar .navbar-button.open span:nth-child(1), :host .site-navbar .navbar-button.open span:nth-child(6) {
  transform: rotate(45deg);
}
:host .site-navbar .navbar-button.open span:nth-child(2), :host .site-navbar .navbar-button.open span:nth-child(5) {
  transform: rotate(-45deg);
}
:host .site-navbar .navbar-button.open span:nth-child(1) {
  left: 3px;
  top: 6px;
}
:host .site-navbar .navbar-button.open span:nth-child(2) {
  left: calc(50% - 3px);
  top: 6px;
}
:host .site-navbar .navbar-button.open span:nth-child(3) {
  left: -50%;
  opacity: 0;
}
:host .site-navbar .navbar-button.open span:nth-child(4) {
  left: 100%;
  opacity: 0;
}
:host .site-navbar .navbar-button.open span:nth-child(5) {
  left: 3px;
  top: 15px;
}
:host .site-navbar .navbar-button.open span:nth-child(6) {
  left: calc(50% - 3px);
  top: 15px;
}
:host .site-navbar .page-title {
  font-size: 2.5rem;
  font-weight: bold;
  line-height: 1;
  color: #555555;
  margin: 0;
  width: 100%;
}
@media screen and (max-width: 2048px) {
  :host .site-navbar .page-title {
    display: none;
  }
}
:host .site-navbar .nav-items {
  display: flex;
  height: 100%;
  margin: 0 -5px;
}
:host .site-navbar .nav-items .nav-item {
  align-items: center;
  display: flex;
  height: 100%;
  margin: 0 5px;
}
@media screen and (min-width: 544px) {
  :host .site-navbar .nav-items .nav-item {
    position: static;
  }
}
:host .site-navbar .nav-items .nav-item ::ng-deep .mat-icon-button,
:host .site-navbar .nav-items .nav-item ::ng-deep .mat-button {
  cursor: pointer;
  min-width: 44px;
  padding: 0;
  transition: color 0.2s ease-in-out;
}
:host .site-navbar .nav-items .nav-item ::ng-deep .mat-icon-button .mat-button-wrapper,
:host .site-navbar .nav-items .nav-item ::ng-deep .mat-button .mat-button-wrapper {
  display: flex;
  height: 100%;
  padding: 5px;
  width: 100%;
}
:host .site-navbar .nav-items .nav-item ::ng-deep .mat-icon-button .mat-button-wrapper .mat-icon,
:host .site-navbar .nav-items .nav-item ::ng-deep .mat-button .mat-button-wrapper .mat-icon {
  font-size: 30px;
  height: 30px;
  line-height: 30px;
  vertical-align: top;
  width: 30px;
}
:host .site-navbar .nav-items .nav-item ::ng-deep .mat-icon-button .mat-button-wrapper .mat-icon .marker,
:host .site-navbar .nav-items .nav-item ::ng-deep .mat-button .mat-button-wrapper .mat-icon .marker {
  background: #00bfff;
  border-radius: 50%;
  height: 6px;
  position: absolute;
  right: 0;
  top: 0;
  width: 6px;
}
.rtl :host .site-navbar .nav-items .nav-item ::ng-deep .mat-icon-button .mat-button-wrapper .mat-icon .marker,
.rtl :host .site-navbar .nav-items .nav-item ::ng-deep .mat-button .mat-button-wrapper .mat-icon .marker {
  left: 0;
  right: auto;
}
:host .site-navbar .nav-items .nav-item ::ng-deep .mat-icon-button .mat-button-wrapper .avatar,
:host .site-navbar .nav-items .nav-item ::ng-deep .mat-button .mat-button-wrapper .avatar {
  border-radius: 50%;
  height: 40px;
  overflow: hidden;
  width: 40px;
}
:host .site-navbar .nav-items .nav-item ::ng-deep .mat-icon-button .mat-button-wrapper .name,
:host .site-navbar .nav-items .nav-item ::ng-deep .mat-button .mat-button-wrapper .name {
  white-space: nowrap;
}
@media screen and (max-width: 2048px) {
  :host .site-navbar .nav-items .nav-item ::ng-deep .mat-icon-button .mat-button-wrapper .name,
  :host .site-navbar .nav-items .nav-item ::ng-deep .mat-button .mat-button-wrapper .name {
    display: none;
  }
}
.rtl :host .site-navbar .nav-items .nav-item ::ng-deep .mat-icon-button .mat-button-wrapper .name,
.rtl :host .site-navbar .nav-items .nav-item ::ng-deep .mat-button .mat-button-wrapper .name {
  padding-left: 0;
  padding-right: 10px;
}
:host .site-navbar .nav-items .nav-item ::ng-deep .mat-icon-button .mat-button-focus-overlay,
:host .site-navbar .nav-items .nav-item ::ng-deep .mat-icon-button .mat-button-ripple,
:host .site-navbar .nav-items .nav-item ::ng-deep .mat-button .mat-button-focus-overlay,
:host .site-navbar .nav-items .nav-item ::ng-deep .mat-button .mat-button-ripple {
  display: none;
}
:host .site-navbar .nav-items .nav-item ::ng-deep .mat-icon-button:hover,
:host .site-navbar .nav-items .nav-item ::ng-deep .mat-button:hover {
  color: #5dade0;
}
:host .site-navbar .nav-items .nav-item .dropdown-menu {
  background: #3c4e62;
  box-shadow: 0 5px 10px 2px rgba(0, 0, 0, 0.25);
  display: none;
  left: 50%;
  margin: 0 0 0 -150px;
  padding: 0;
  position: absolute;
  top: 100%;
  width: 300px;
  z-index: 9999;
}
@media screen and (max-width: 2048px) {
  :host .site-navbar .nav-items .nav-item .dropdown-menu {
    left: auto;
    margin-left: 0;
    right: 0;
  }
}
@media screen and (max-width: 543px) {
  :host .site-navbar .nav-items .nav-item .dropdown-menu {
    left: 0;
    margin-left: 0;
    width: 100%;
  }
}
.rtl :host .site-navbar .nav-items .nav-item .dropdown-menu {
  left: auto;
  margin: 0 -150px 0 0;
  right: 50%;
}
@media screen and (max-width: 2048px) {
  .rtl :host .site-navbar .nav-items .nav-item .dropdown-menu {
    left: 0;
    margin-right: 0;
    right: auto;
  }
}
@media screen and (max-width: 543px) {
  .rtl :host .site-navbar .nav-items .nav-item .dropdown-menu {
    margin-right: 0;
    right: 0;
  }
}
:host .site-navbar .nav-items .nav-item .dropdown-menu:before {
  border: 10px solid transparent;
  border-bottom-color: #3c4e62;
  bottom: 100%;
  content: "";
  left: 50%;
  margin: 0 0 0 -10px;
  position: absolute;
}
@media screen and (max-width: 2048px) {
  :host .site-navbar .nav-items .nav-item .dropdown-menu:before {
    left: 100%;
    margin-left: -34px;
  }
}
@media screen and (max-width: 543px) {
  :host .site-navbar .nav-items .nav-item .dropdown-menu:before {
    display: none;
  }
}
:host .site-navbar .nav-items .nav-item .dropdown-menu .menu-title,
:host .site-navbar .nav-items .nav-item .dropdown-menu .menu-footer {
  margin: 0;
  padding: 11px;
  text-align: center;
}
:host .site-navbar .nav-items .nav-item .dropdown-menu .menu-title {
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  color: #fff;
  font-size: 16px;
  line-height: 1.3;
}
:host .site-navbar .nav-items .nav-item .dropdown-menu .menu-footer {
  background: #36475a;
}
:host .site-navbar .nav-items .nav-item .dropdown-menu .menu-footer a {
  color: #fff;
}
:host .site-navbar .nav-items .nav-item .dropdown-menu .menu-footer a:hover {
  color: rgba(255, 255, 255, 0.8);
}
:host .site-navbar .nav-items .nav-item .dropdown-menu > ul {
  list-style-type: none;
  margin: 0;
  max-height: 241px;
  overflow: auto;
  padding: 0;
}
:host .site-navbar .nav-items .nav-item .dropdown-menu > ul > li {
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}
:host .site-navbar .nav-items .nav-item .dropdown-menu > ul > li:last-child {
  border-bottom: 0;
}
:host .site-navbar .nav-items .nav-item .dropdown-menu > ul > li > a {
  align-items: center;
  color: #fff;
  display: flex;
  padding: 11px;
  transition: background 0.2s ease-in-out;
}
:host .site-navbar .nav-items .nav-item .dropdown-menu > ul > li > a:hover {
  background: #5dade0;
}
:host .site-navbar .nav-items .nav-item .dropdown-menu > ul > li > a .mat-icon {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  font-size: 26px;
  height: auto;
  margin-right: 11px;
  padding: 7px;
  width: auto;
}
.rtl :host .site-navbar .nav-items .nav-item .dropdown-menu > ul > li > a .mat-icon {
  margin-right: 0;
  margin-left: 11px;
}
:host .site-navbar .nav-items .nav-item .dropdown-menu > ul > li > a .avatar {
  border-radius: 50%;
  height: 40px;
  margin-right: 11px;
  width: 40px;
}
.rtl :host .site-navbar .nav-items .nav-item .dropdown-menu > ul > li > a .avatar {
  margin-right: 0;
  margin-left: 11px;
}
:host .site-navbar .nav-items .nav-item .dropdown-menu > ul > li > a .content {
  font-size: 0.85rem;
}
:host .site-navbar .nav-items .nav-item .dropdown-menu > ul > li > a .content .desc {
  display: block;
}
:host .site-navbar .nav-items .nav-item .dropdown-menu > ul > li > a .content .date {
  display: block;
  font-size: 0.75rem;
  font-style: italic;
  margin-top: 4px;
  opacity: 0.6;
}
:host .site-navbar .nav-items .nav-item .dropdown-menu > ul > li > a .content .meta {
  align-items: flex-end;
  display: flex;
  justify-content: space-between;
  line-height: 1.3;
  margin-bottom: 4px;
}
:host .site-navbar .nav-items .nav-item .dropdown-menu > ul > li > a .content .meta .date {
  margin: 0 0 0 11px;
}
:host .site-navbar .nav-items .nav-item .dropdown-menu.mini-menu {
  left: auto;
  right: 0;
  width: 220px;
}
@media screen and (max-width: 543px) {
  :host .site-navbar .nav-items .nav-item .dropdown-menu.mini-menu {
    width: 100%;
  }
}
.rtl :host .site-navbar .nav-items .nav-item .dropdown-menu.mini-menu {
  left: 0;
  right: auto;
}
:host .site-navbar .nav-items .nav-item .dropdown-menu.mini-menu:before {
  display: none;
}
:host .site-navbar .nav-items .nav-item .dropdown-menu.mini-menu > ul > li > a {
  padding-top: 8px;
  padding-bottom: 8px;
}
:host .site-navbar .nav-items .nav-item .dropdown-menu.mini-menu > ul > li > a .fa {
  margin-right: 11px;
  min-width: 15px;
}
.rtl :host .site-navbar .nav-items .nav-item .dropdown-menu.mini-menu > ul > li > a .fa {
  margin-left: 11px;
  margin-right: 0;
}
:host .site-navbar .nav-items .nav-item.opened ::ng-deep .mat-icon-button,
:host .site-navbar .nav-items .nav-item.opened ::ng-deep .mat-button {
  color: #5dade0;
}
:host .site-navbar .nav-items .nav-item.opened .dropdown-menu {
  display: block;
}
:host .site-navbar .nav-items .nav-item.opened ~ .items-overlay {
  opacity: 1;
  transition: 0.2s opacity 0s ease-in-out, 0s visibility 0s ease-in-out;
  visibility: visible;
}
:host .site-navbar .nav-items .items-overlay {
  background: rgba(60, 78, 98, 0.2);
  height: 100%;
  left: 0;
  opacity: 0;
  position: fixed;
  top: 0;
  transition: 0.2s opacity 0s ease-in-out, 0s visibility 0.2s ease-in-out;
  visibility: hidden;
  width: 100%;
  z-index: 9998;
}`, "",{"version":3,"sources":["webpack://./src/app/rt-components/navbar/navbar.component.scss","webpack://./src/assets/sass/_variable.scss"],"names":[],"mappings":"AAEA;EACE,YAAA;EACA,8BAAA;EACA,2BAAA;EACA,8BAAA;EACA,2BAAA;AADF;;AAGA;EACE,2BAAA;AAAF;;AAEA;EACE,sBAAA;AACF;;AACA;EACE,mBAAA;EACA,gCAAA;EACA,cAAA;EACA,YAAA;EACA,WCVc;EDWd,eAAA;EACA,QAAA;EACA,MAAA;EACA,aAAA;AAEF;AADE;EAVF;IAWI,OAAA;EAIF;AACF;AAFE;EACE,OAAA;EACA,YCrBY;ADyBhB;AAHI;EAHF;IAII,QAAA;EAMJ;AACF;AAJE;EACE,mBAAA;EACA,aAAA;EACA,iBAAA;EACA,YAAA;EACA,8BAAA;EACA,eAAA;AAMJ;AALI;EAPF;IAQI,eAAA;EAQJ;AACF;AANI;EACE,eAAA;EACA,aAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;EACA,uBAAA;EACA,WAAA;AAQN;AAPM;EARF;IASI,cAAA;EAUN;AACF;AARM;EACE,mBAAA;EACA,cAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;EACA,uBAAA;EACA,6BAAA;EACA,UAAA;AAUR;AARQ;EACE,SAAA;AAUV;AARQ;EACE,SAAA;AAUV;AARQ;EAEE,QAAA;AASV;AAPQ;EAEE,SAAA;AAQV;AANQ;EAEE,SAAA;AAOV;AAFU;EAEE,wBAAA;AAGZ;AADU;EAEE,yBAAA;AAEZ;AAAU;EACE,SAAA;EACA,QAAA;AAEZ;AAAU;EACE,qBAAA;EACA,QAAA;AAEZ;AAAU;EACE,UAAA;EACA,UAAA;AAEZ;AAAU;EACE,UAAA;EACA,UAAA;AAEZ;AAAU;EACE,SAAA;EACA,SAAA;AAEZ;AAAU;EACE,qBAAA;EACA,SAAA;AAEZ;AAGI;EACE,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,cAAA;EACA,SAAA;EACA,WAAA;AADN;AAEM;EAPF;IAQI,aAAA;EACN;AACF;AACI;EACE,aAAA;EACA,YAAA;EACA,cAAA;AACN;AACM;EACE,mBAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;AACR;AAAQ;EALF;IAMI,gBAAA;EAGR;AACF;AAAU;;EAGE,eAAA;EACA,eAAA;EACA,UAAA;EACA,kCAAA;AACZ;AACY;;EACE,aAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;AAEd;AAAc;;EACE,eAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,WAAA;AAGhB;AADgB;;EACE,mBCnJL;EDoJK,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,UAAA;AAIlB;AAFkB;;EACE,OAAA;EACA,WAAA;AAKpB;AADc;;EACE,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;AAIhB;AAFc;;EAEE,mBAAA;AAIhB;AAHgB;EAHF;;IAII,aAAA;EAOhB;AACF;AANgB;;EACE,eAAA;EACA,mBAAA;AASlB;AALY;;;;EAEE,aAAA;AASd;AAPY;;EACE,cAAA;AAUd;AANQ;EACE,mBAAA;EACA,8CAAA;EACA,aAAA;EACA,SAAA;EACA,oBAAA;EACA,UAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,aAAA;AAQV;AAPU;EAXF;IAYI,UAAA;IACA,cAAA;IACA,QAAA;EAUV;AACF;AATU;EAhBF;IAiBI,OAAA;IACA,cAAA;IACA,WAAA;EAYV;AACF;AAVU;EACE,UAAA;EACA,oBAAA;EACA,UAAA;AAYZ;AAXY;EAJF;IAKI,OAAA;IACA,eAAA;IACA,WAAA;EAcZ;AACF;AAbY;EATF;IAUI,eAAA;IACA,QAAA;EAgBZ;AACF;AAdU;EACE,8BAAA;EACA,4BAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;AAgBZ;AAfY;EARF;IASI,UAAA;IACA,kBAAA;EAkBZ;AACF;AAjBY;EAZF;IAaI,aAAA;EAoBZ;AACF;AAlBU;;EAEE,SAAA;EACA,aAAA;EACA,kBAAA;AAoBZ;AAlBU;EACE,iDAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;AAoBZ;AAlBU;EACE,mBAAA;AAoBZ;AAlBY;EACE,WAAA;AAoBd;AAlBc;EACE,+BAAA;AAoBhB;AAhBU;EACE,qBAAA;EACA,SAAA;EACA,iBAAA;EACA,cAAA;EACA,UAAA;AAkBZ;AAhBY;EACE,kDAAA;AAkBd;AAhBc;EACE,gBAAA;AAkBhB;AAhBc;EACE,mBAAA;EACA,WAAA;EACA,aAAA;EACA,aAAA;EACA,uCAAA;AAkBhB;AAhBgB;EACE,mBAAA;AAkBlB;AAhBgB;EACE,oCAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;AAkBlB;AAhBkB;EACE,eAAA;EACA,iBAAA;AAkBpB;AAfgB;EACE,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;AAiBlB;AAfkB;EACE,eAAA;EACA,iBAAA;AAiBpB;AAdgB;EACE,kBAAA;AAgBlB;AAdkB;EACE,cAAA;AAgBpB;AAdkB;EACE,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;AAgBpB;AAdkB;EACE,qBAAA;EACA,aAAA;EACA,8BAAA;EACA,gBAAA;EACA,kBAAA;AAgBpB;AAdoB;EACE,kBAAA;AAgBtB;AATU;EACE,UAAA;EACA,QAAA;EACA,YAAA;AAWZ;AAVY;EAJF;IAKI,WAAA;EAaZ;AACF;AAXY;EACE,OAAA;EACA,WAAA;AAad;AAXY;EACE,aAAA;AAad;AATgB;EACE,gBAAA;EACA,mBAAA;AAWlB;AATkB;EACE,kBAAA;EACA,eAAA;AAWpB;AAToB;EACE,iBAAA;EACA,eAAA;AAWtB;AADY;;EAEE,cAAA;AAGd;AAAU;EACE,cAAA;AAEZ;AAAU;EACE,UAAA;EACA,qEACE;EAEF,mBAAA;AAAZ;AAIM;EACE,iCAAA;EACA,YAAA;EACA,OAAA;EACA,UAAA;EACA,eAAA;EACA,MAAA;EACA,uEACE;EAEF,kBAAA;EACA,WAAA;EACA,aAAA;AAJR","sourcesContent":["@import '../../../assets/sass/variable';\r\n\r\n.buttonNavbar{\r\n  border: none;\r\n  border-radius: 30px !important;\r\n  padding-top: 7px !important;\r\n  padding-bottom: 7px !important;\r\n  background-color: lightgrey;\r\n}\r\n.buttonNavbar1:hover{\r\n  color: lightgray !important;\r\n}\r\n.buttonNavbar2:hover{\r\n  color: gray !important;\r\n}\r\n:host {\r\n  background: #ffffff;\r\n  border-bottom: 1px solid #dfe4ed;\r\n  display: block;\r\n  height: 70px;\r\n  left: $sidebar-width;\r\n  position: fixed;\r\n  right: 0;\r\n  top: 0;\r\n  z-index: 9998;\r\n  @media screen and (max-width: 2048px) {\r\n    left: 0;\r\n  }\r\n\r\n  .rtl & {\r\n    left: 0;\r\n    right: $sidebar-width;\r\n    @media screen and (max-width: 2048px) {\r\n      right: 0;\r\n    }\r\n  }\r\n  .site-navbar {\r\n    align-items: center;\r\n    display: flex;\r\n    flex-wrap: nowrap;\r\n    height: 100%;\r\n    justify-content: space-between;\r\n    padding: 0 22px;\r\n    @media screen and (max-width: 2048px) {\r\n      flex-wrap: wrap;\r\n    }\r\n\r\n    .navbar-button {\r\n      cursor: pointer;\r\n      display: none;\r\n      height: 24px;\r\n      margin: 0;\r\n      position: relative;\r\n      transform: rotate(0deg);\r\n      width: 30px;\r\n      @media screen and (max-width: 2048px) {\r\n        display: block;\r\n      }\r\n    \r\n      span {\r\n        background: main-color(500);\r\n        display: block;\r\n        height: 3px;\r\n        opacity: 1;\r\n        position: absolute;\r\n        transform: rotate(0deg);\r\n        transition: .25s $animation;\r\n        width: 50%;\r\n\r\n        &:nth-child(even) {\r\n          left: 50%;\r\n        }\r\n        &:nth-child(odd) {\r\n          left: 0px;\r\n        }\r\n        &:nth-child(1),\r\n        &:nth-child(2) {\r\n          top: 0px;\r\n        }\r\n        &:nth-child(3),\r\n        &:nth-child(4) {\r\n          top: 10px;\r\n        }\r\n        &:nth-child(5),\r\n        &:nth-child(6) {\r\n          top: 20px;\r\n        }\r\n      }\r\n      &.open {\r\n        span {\r\n          &:nth-child(1),\r\n          &:nth-child(6) {\r\n            transform: rotate(45deg);\r\n          }\r\n          &:nth-child(2),\r\n          &:nth-child(5) {\r\n            transform: rotate(-45deg);\r\n          }\r\n          &:nth-child(1) {\r\n            left: 3px;\r\n            top: 6px;\r\n          }\r\n          &:nth-child(2) {\r\n            left: calc(50% - 3px);\r\n            top: 6px;\r\n          }\r\n          &:nth-child(3) {\r\n            left: -50%;\r\n            opacity: 0;\r\n          }\r\n          &:nth-child(4) {\r\n            left: 100%;\r\n            opacity: 0;\r\n          }\r\n          &:nth-child(5) {\r\n            left: 3px;\r\n            top: 15px;\r\n          }\r\n          &:nth-child(6) {\r\n            left: calc(50% - 3px);\r\n            top: 15px;\r\n          }\r\n        }\r\n      }\r\n    }\r\n    .page-title {\r\n      font-size: 2.5rem;\r\n      font-weight: bold;\r\n      line-height: 1;\r\n      color: #555555;\r\n      margin: 0;\r\n      width: 100%;\r\n      @media screen and (max-width: 2048px) {\r\n        display: none;\r\n      }\r\n    }\r\n    .nav-items {\r\n      display: flex;\r\n      height: 100%;\r\n      margin: 0 -5px;\r\n\r\n      .nav-item {\r\n        align-items: center;\r\n        display: flex;\r\n        height: 100%;\r\n        margin: 0 5px;\r\n        @media screen and (min-width: 544px) {\r\n          position: static;\r\n        }\r\n\r\n        ::ng-deep {\r\n          .mat-icon-button,\r\n          .mat-button {\r\n          //color: rgba(#000,.3);\r\n            cursor: pointer;\r\n            min-width: 44px;\r\n            padding: 0;\r\n            transition: color .2s $animation;\r\n\r\n            .mat-button-wrapper {\r\n              display: flex;\r\n              height: 100%;\r\n              padding: 5px;\r\n              width: 100%;\r\n\r\n              .mat-icon {\r\n                font-size: 30px;\r\n                height: 30px;\r\n                line-height: 30px;\r\n                vertical-align: top;\r\n                width: 30px;\r\n\r\n                .marker {\r\n                  background: $info-color;\r\n                  border-radius: 50%;\r\n                  height: 6px;\r\n                  position: absolute;\r\n                  right: 0;\r\n                  top: 0;\r\n                  width: 6px;\r\n\r\n                  .rtl & {\r\n                    left: 0;\r\n                    right: auto;\r\n                  }\r\n                }\r\n              }\r\n              .avatar {\r\n                border-radius: 50%;\r\n                height: 40px;\r\n                overflow: hidden;\r\n                width: 40px;\r\n              }\r\n              .name {\r\n                // padding-left: 10px;\r\n                white-space: nowrap;\r\n                @media screen and (max-width: 2048px) {\r\n                  display: none;\r\n                }\r\n                .rtl & {\r\n                  padding-left: 0;\r\n                  padding-right: 10px;\r\n                }\r\n              }\r\n            }\r\n            .mat-button-focus-overlay,\r\n            .mat-button-ripple {\r\n              display: none;\r\n            }\r\n            &:hover {\r\n              color: main-color(A100);\r\n            }\r\n          }\r\n        }\r\n        .dropdown-menu {\r\n          background: main-color(500);\r\n          box-shadow: 0 5px 10px 2px rgba(#000,.25);\r\n          display: none;\r\n          left: 50%;\r\n          margin: 0 0 0 -150px;\r\n          padding: 0;\r\n          position: absolute;\r\n          top: 100%;\r\n          width: 300px;\r\n          z-index: 9999;\r\n          @media screen and (max-width: 2048px) {\r\n            left: auto;\r\n            margin-left: 0;\r\n            right: 0;\r\n          }\r\n          @media screen and (max-width: 543px) {\r\n            left: 0;\r\n            margin-left: 0;\r\n            width: 100%;\r\n          }\r\n\r\n          .rtl & {\r\n            left: auto;\r\n            margin: 0 -150px 0 0;\r\n            right: 50%;\r\n            @media screen and (max-width: 2048px) {\r\n              left: 0;\r\n              margin-right: 0;\r\n              right: auto;\r\n            }\r\n            @media screen and (max-width: 543px) {\r\n              margin-right: 0;\r\n              right: 0;\r\n            }\r\n          }\r\n          &:before {\r\n            border: 10px solid transparent;\r\n            border-bottom-color: main-color(500);\r\n            bottom: 100%;\r\n            content: '';\r\n            left: 50%;\r\n            margin: 0 0 0 -10px;\r\n            position: absolute;\r\n            @media screen and (max-width: 2048px) {\r\n              left: 100%;\r\n              margin-left: -34px;\r\n            }\r\n            @media screen and (max-width: 543px) {\r\n              display: none;\r\n            }\r\n          }\r\n          .menu-title,\r\n          .menu-footer {\r\n            margin: 0;\r\n            padding: 11px;\r\n            text-align: center;\r\n          }\r\n          .menu-title {\r\n            border-bottom: 1px solid rgba(#fff,.1);\r\n            color: #fff;\r\n            font-size: 16px;\r\n            line-height: 1.3;\r\n          }\r\n          .menu-footer {\r\n            background: main-color(600);\r\n\r\n            a {\r\n              color: #fff;\r\n\r\n              &:hover {\r\n                color: rgba(#fff,.8);\r\n              }\r\n            }\r\n          }\r\n          > ul {\r\n            list-style-type: none;\r\n            margin: 0;\r\n            max-height: 241px;\r\n            overflow: auto;\r\n            padding: 0;\r\n\r\n            > li {\r\n              border-bottom: 1px solid rgba(#fff,.05);\r\n\r\n              &:last-child {\r\n                border-bottom: 0;\r\n              }\r\n              > a {\r\n                align-items: center;\r\n                color: #fff;\r\n                display: flex;\r\n                padding: 11px;\r\n                transition: background .2s $animation;\r\n\r\n                &:hover {\r\n                  background: main-color(A100);\r\n                }\r\n                .mat-icon {\r\n                  background: rgba(#fff,.1);\r\n                  border-radius: 50%;\r\n                  font-size: 26px;\r\n                  height: auto;\r\n                  margin-right: 11px;\r\n                  padding: 7px;\r\n                  width: auto;\r\n\r\n                  .rtl & {\r\n                    margin-right: 0;\r\n                    margin-left: 11px;\r\n                  }\r\n                }\r\n                .avatar {\r\n                  border-radius: 50%;\r\n                  height: 40px;\r\n                  margin-right: 11px;\r\n                  width: 40px;\r\n\r\n                  .rtl & {\r\n                    margin-right: 0;\r\n                    margin-left: 11px;\r\n                  }\r\n                }\r\n                .content {\r\n                  font-size: .85rem;\r\n\r\n                  .desc {\r\n                    display: block;\r\n                  }\r\n                  .date {\r\n                    display: block;\r\n                    font-size: .75rem;\r\n                    font-style: italic;\r\n                    margin-top: 4px;\r\n                    opacity: .6;\r\n                  }\r\n                  .meta {\r\n                    align-items: flex-end;\r\n                    display: flex;\r\n                    justify-content: space-between;\r\n                    line-height: 1.3;\r\n                    margin-bottom: 4px;\r\n\r\n                    .date {\r\n                      margin: 0 0 0 11px;\r\n                    }\r\n                  }\r\n                }\r\n              }\r\n            }\r\n          }\r\n          &.mini-menu {\r\n            left: auto;\r\n            right: 0;\r\n            width: 220px;\r\n            @media screen and (max-width: 543px) {\r\n              width: 100%;\r\n            }\r\n\r\n            .rtl & {\r\n              left: 0;\r\n              right: auto;\r\n            }\r\n            &:before {\r\n              display: none;\r\n            }\r\n            > ul {\r\n              > li {\r\n                > a {\r\n                  padding-top: 8px;\r\n                  padding-bottom: 8px;\r\n\r\n                  .fa {\r\n                    margin-right: 11px;\r\n                    min-width: 15px;\r\n\r\n                    .rtl & {\r\n                      margin-left: 11px;\r\n                      margin-right: 0;\r\n                    }\r\n                  }\r\n                }\r\n              }\r\n            }\r\n          }\r\n        }\r\n        &.opened {\r\n          ::ng-deep {\r\n            .mat-icon-button,\r\n            .mat-button {\r\n              color: main-color(A100);\r\n            }\r\n          }\r\n          .dropdown-menu {\r\n            display: block;\r\n          }\r\n          ~ .items-overlay {\r\n            opacity: 1;\r\n            transition:\r\n              .2s opacity 0s $animation,\r\n              0s visibility 0s $animation;\r\n            visibility: visible;\r\n          }\r\n        }\r\n      }\r\n      .items-overlay {\r\n        background: rgba(main-color(500),.2);\r\n        height: 100%;\r\n        left: 0;\r\n        opacity: 0;\r\n        position: fixed;\r\n        top: 0;\r\n        transition:\r\n          .2s opacity 0s $animation,\r\n          0s visibility .2s $animation;\r\n        visibility: hidden;\r\n        width: 100%;\r\n        z-index: 9998;\r\n      }\r\n    }\r\n  }\r\n}\r\n","$main-fs: 14px;\r\n$main-ff: 'Open Sans', sans-serif;\r\n$main-fw: 400;\r\n$main-lh: 1.5714286;\r\n$module: 1.5714286rem;\r\n\r\n$second-ff: 'Nunito Sans', sans-serif;\r\n\r\n$animation: ease-in-out;\r\n\r\n$sidebar-width: 220px;\r\n\r\n$max543 : only screen and (max-width: 543px);\r\n$min544 : only screen and (min-width: 544px);\r\n$max767 : only screen and (max-width: 767px);\r\n$min768 : only screen and (min-width: 768px);\r\n$max991 : only screen and (max-width: 991px);\r\n$min992 : only screen and (min-width: 992px);\r\n$max1199 : only screen and (max-width: 1199px);\r\n$max2048 : only screen and (max-width: 2048px);\r\n$min1200 : only screen and (min-width: 1200px);\r\n\r\n$headers-ff: $second-ff;\r\n$headers-fw: 700;\r\n\r\n$success-color: #008000;\r\n$info-color: #00bfff;\r\n$warning-color: #ff8c00;\r\n$danger-color: #dc143c;\r\n\r\n$main-color: (\r\n  50 : #e8eaec,\r\n  100 : #c5cad0,\r\n  200 : #9ea7b1,\r\n  300 : #778391,\r\n  400 : #59697a,\r\n  500 : #3c4e62,\r\n  600 : #36475a,\r\n  700 : #2e3d50,\r\n  800 : #273546,\r\n  900 : #1a2534,\r\n  A100 : #5dade0,\r\n  A200 : #2694d9,\r\n  A400 : #0e7cc5,\r\n  A700 : #03568b,\r\n  contrast: (\r\n    50 : #000000,\r\n    100 : #000000,\r\n    200 : #000000,\r\n    300 : #000000,\r\n    400 : #ffffff,\r\n    500 : #ffffff,\r\n    600 : #ffffff,\r\n    700 : #ffffff,\r\n    800 : #ffffff,\r\n    900 : #ffffff,\r\n    A100 : #ffffff,\r\n    A200 : #ffffff,\r\n    A400 : #ffffff,\r\n    A700 : #ffffff,\r\n  )\r\n);\r\n@function main-color($key: $main-color) {\r\n  @return map-get($main-color, $key);\r\n}\r\n$accent-palette: (\r\n  50 : #ecf5fb,\r\n  100 : #cee6f6,\r\n  200 : #aed6f0,\r\n  300 : #8ec6e9,\r\n  400 : #75b9e5,\r\n  500 : #5dade0,\r\n  600 : #55a6dc,\r\n  700 : #4b9cd8,\r\n  800 : #4193d3,\r\n  900 : #3083cb,\r\n  A100 : #ffffff,\r\n  A200 : #dceeff,\r\n  A400 : #a9d5ff,\r\n  A700 : #90c9ff,\r\n  A800 : #EC4343,\r\n  contrast: (\r\n    50 : #000000,\r\n    100 : #000000,\r\n    200 : #000000,\r\n    300 : #000000,\r\n    400 : #000000,\r\n    500 : #ffffff,\r\n    600 : #000000,\r\n    700 : #000000,\r\n    800 : #000000,\r\n    900 : #ffffff,\r\n    A100 : #000000,\r\n    A200 : #000000,\r\n    A400 : #000000,\r\n    A700 : #000000,\r\n    A800 : #000000\r\n  )\r\n);\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
